import { gql } from "@apollo/client";

export interface LANControllerConfig {
	cpuId: string
	macAddress: string
	ipAddress: string
	firmwareVersion: string
	serverProtocolVersion: string
	tableDefinitionVersion: string
	productName: string
	hardwareVersion: string
	productionDate: string
}

export const LAN_CONTROLLER_CONFIG = gql`
query Config($domain: String!, $lanControllerId: Int!) {
	controller {
		config(domain: $domain, lanControllerId: $lanControllerId) {
			cpuId
			macAddress
			ipAddress
			firmwareVersion
			serverProtocolVersion
			tableDefinitionVersion
			productName
			hardwareVersion
			productionDate
		}
	}
}
`

export interface LANControllerConfigResponse {
	controller: {
		config: LANControllerConfig | null
	}
}

export interface LANControllerConfigArgs {
	domain: string;
	lanControllerId: number;
}

